import React from "react";


export const AppNotFound = () => (
    <b>NotFounde</b>
)